import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import PN from "persian-number";
import Drp_Brand from '../ProductBrand/Drp_Brand';
import Drp_Group from '../ProductGroup/Drp_Group';
import Drp_ParentGroup from '../ProductGroup/Drp_Group';


const SalesSituationIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const SearchBrandRef = useRef();
    const SearchGroupRef = useRef();
    const SearchParentGroupRef = useRef();
    const [ProductList, setProductList] = useState([]);
    const [SearchTitle, setSearchTitle] = useState('');
    const [SearchGroupId, setSearchGroupId] = useState(-1);
    const [SearchParentGroupId, setSearchParentGroupId] = useState(-1);
    const [SearchBrandId, setSearchBrantId] = useState(-1);
    const [SearchIsActive, setSearchIsActive] = useState(1);
    const [SearchWebIsActive, setSearchWebIsActive] = useState(1);
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)

    const CompactCell = props => <rsuite.Table.Cell {...props} />;
    const CompactHeaderCell = props => <rsuite.Table.HeaderCell {...props} />;
    const defaultColumns = [

        {
            key: 'ParentTitle',
            label: 'گروه',
            fullText: true,
            sortable: true,
            fixed: true,
            flexGrow: 1
        },
        {
            key: 'GroupTitle',
            label: 'زیر گروه',
            fixed: true,
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1
        },
        {
            key: 'BrandTitle',
            label: ' برند',
            fixed: true,
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1
        },


    ];




    const [compact, setCompact] = React.useState(true);
    const [columnKeys, setColumnKeys] = React.useState(defaultColumns.map(column => column.key));

    const columns = defaultColumns.filter(column => columnKeys.some(key => key === column.key, className => className === column.className));
    const CustomCell = compact ? CompactCell : rsuite.Table.Cell;
    const CustomHeaderCell = compact ? CompactHeaderCell : rsuite.Table.HeaderCell;


    //#endregion




    const SearchParent_Change = (value) => {
        setSearchParentGroupId(value);
        SearchGroupRef.current.BindGroupByParentId(0, value)
    }

    //#region Methods

    const Search = () => {
        if (SearchBrandId == -1 && SearchParentGroupId == -1 && SearchTitle == "" && SearchGroupId == -1)
            toaster.push(General.ShowMessage('error', General.ErrorMessage("  انتخاب یکی از فیلترهای جسنجو اجباری می باشد")), 'topCenter')
        else {
            trackPromise(
                fetch(General.ApiRoute() + '/Product/SearchForUpdateSituation', {
                    method: 'Get',
                    headers: {
                        'ApiKey': General.APIKey(),
                        'BrandId': SearchBrandId,
                        'ProductGroupId': SearchGroupId,
                        'ProductGroupParentId': SearchParentGroupId,
                        'Title': SearchTitle,
                        'WebIsActive': -1,
                        'IsActive': -1
                    },
                    credentials: 'include'
                })
                    .then(res => res.json())
                    .then(result => {
                        var tmp = []
                        for (var i = 0; i < result.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                Id: result[i].id,
                                LastPrice: result[i].lastPrice,
                                LastPriceCoworker: result[i].lastPriceCoworker,
                                WebIsActive: result[i].webIsActive,
                                IsActive: result[i].isActive,
                                Title: result[i].title,
                                ParentTitle: result[i].parentTitle,
                                GroupTitle: result[i].groupTitle,
                                BrandTitle: result[i].brandTitle,
                                IdentityNo: result[i].identityNo,
                                // PhotoTag: result[i].photoTag,
                                // HasCatalog: result[i].hasCatalog,
                                // PhotoCount: result[i].photoCount,
                                SaleType: result[i].saleType,
                                Power: result[i].power,
                                Current: result[i].current,
                                Unit: result[i].unit,
                                SaleCount: result[i].saleCount,
                                OnlineStoreId: result[i].onlineStoreId,
                                Store: result[i].store,
                                storeList: result[i].storeList,
                                IsToday: result[i].isToday,
                                SaleTypeComment: result[i].saleType == 1 ? "قابل فروش" : result[i].saleType == 2 ? "قابل رزرو" : result[i].saleType == 3 ? "غیر قابل فروش" : "",

                            })
                        }
                        setProductList(tmp)
                    })
            )
        }
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };

    const Change_Item = (row, value, dataType) => {
        var temp = [...ProductList];
        var index = temp.findIndex(x => x.Row == row);

        if (index != -1) {
            temp[index].IsToday = 1;
            if (dataType == "SaleType")
                temp[index].SaleType = value.target.value;
            else if (dataType == "WebIsActive")
                temp[index].WebIsActive = value == true ? 1 : 0;
            else if (dataType == "Store") {
                temp[index].OnlineStoreId = value.target.value;
                var innerIndex = temp[index].storeList.findIndex(x => x.id == value.target.value);
                temp[index].Store = temp[index].storeList[innerIndex]["title"];
                temp[index].SaleCount = temp[index].storeList[innerIndex]["saleCount"];
            }
            else
                temp[index].IsActive = value == true ? 1 : 0;
        }
        setProductList(temp);
    }


    const Save = () => {

        var RequestOptions = {
            data: {
                Id: General.GuidEmpty(),
                "ProductList": ProductList

            },
            url: General.ApiRoute() + "/Product/UpdateSaleSituation",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        Search();
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }






    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 57);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        SearchBrandRef.current.BindBrand(-1);
                        SearchParentGroupRef.current.BindGroupByParentId(-1, 0);

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }




    useEffect(() => {
        CheckPermission();
        document.title = "به روز رسانی وضعیت فروش محصولات ";
    }, [])
    //#endregion







    return (

        <Layout title="به روز رسانی وضعیت فروش محصولات ">


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white h-10 ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={Save}>  ثبت</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>عتوان   </label>
                            <rsuite.Input value={SearchTitle} onChange={(e) => setSearchTitle(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>گروه   </label>
                            <Drp_ParentGroup className="rs-input" value={SearchParentGroupId} onChange={SearchParent_Change} ref={SearchParentGroupRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>زیر گروه   </label>
                            <Drp_Group className="rs-input" value={SearchGroupId} onChange={(value) => setSearchGroupId(value)} ref={SearchGroupRef} />
                        </rsuite.Col>

                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> برند   </label>
                            <Drp_Brand className="rs-input" value={SearchBrandId} onChange={(value) => setSearchBrantId(value)} ref={SearchBrandRef} />
                        </rsuite.Col>



                    </rsuite.Row>
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <label> فیلتر   </label>
                            <rsuite.VStack spacing={16}>

                                <rsuite.TagPicker
                                    data={defaultColumns}
                                    labelKey="label"
                                    valueKey="key"
                                    value={columnKeys}
                                    onChange={setColumnKeys}
                                    cleanable={false}
                                    className='Font10 w-100p'
                                />
                            </rsuite.VStack>
                        </rsuite.Col>
                    </rsuite.Row>

                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    height={520}
                                    data={ProductList.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    })}

                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}



                                >
                                    <rsuite.Table.Column fullText className="w-10p" align="center" fixed sortable>
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Row" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={3} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>عنوان</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell  >
                                            {(rowData) => {
                                                return <>
                                                    <text className={rowData.IsToday ? 'text-success fw-bold' : ""}>
                                                        {rowData.Title}
                                                    </text>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    {columns.map(column => {
                                        const { key, label, ...rest } = column;
                                        return (
                                            <rsuite.Table.Column {...rest} key={key}>
                                                <CustomHeaderCell>{label}</CustomHeaderCell>
                                                <CustomCell>
                                                    {(column) => {
                                                        return <>
                                                            <text className={column.IsToday ? 'text-success fw-bold' : ""}>

                                                                {key == "LastPrice" ?
                                                                    <>{PN.sliceNumber(column.LastPrice)}</>
                                                                    : key == "LastPriceCoworker" ?
                                                                        <>{PN.sliceNumber(column.LastPriceCoworker)}</>
                                                                        : key == "BrandTitle" ?
                                                                            <>{column.BrandTitle}</>
                                                                            : key == "GroupTitle" ?
                                                                                <>{column.GroupTitle}</>
                                                                                :
                                                                                <>{column.ParentTitle}</>

                                                                }
                                                            </text>
                                                        </>
                                                    }}


                                                </CustomCell>
                                            </rsuite.Table.Column>
                                        );
                                    })}





                                    <rsuite.Table.Column flexGrow={2} sortable resizable>
                                        <rsuite.Table.HeaderCell > نوع فروش آنلاین </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell >
                                            {(rowData) => {
                                                return <>
                                                    <select className={rowData.IsToday ? 'text-success fw-bold rs-input' : "rs-input"} onChange={value => {
                                                        Change_Item?.(rowData.Row, value, 'SaleType');
                                                    }} value={rowData.SaleType}>
                                                        <option value="-1">انتخاب نمایید</option>
                                                        <option value="1">قابل فروش </option>
                                                        <option value="2">قابل رزرو </option>
                                                        <option value="3">غیر قابل فروش </option>
                                                    </select>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={3} sortable resizable>
                                        <rsuite.Table.HeaderCell > انبار فروش آنلاین </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell >
                                            {(rowData) => {
                                                return <>
                                                    <select className={rowData.IsToday ? 'text-success fw-bold rs-input' : "rs-input"} onChange={value => {
                                                        Change_Item?.(rowData.Row, value, 'Store');
                                                    }} value={rowData.OnlineStoreId}>
                                                        <option value="-1">انتخاب نمایید</option>
                                                        {rowData.storeList.map(item => (
                                                            <option value={item.id}> {item.title} ( قابل فروش : {item.saleCount} {rowData.Unit} ) </option>
                                                        ))}
                                                    </select>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>



                                    <rsuite.Table.Column flexGrow={2} sortable resizable>
                                        <rsuite.Table.HeaderCell > وضعیت فروش حضوری </rsuite.Table.HeaderCell>


                                        <rsuite.Table.Cell  >
                                            {(rowData) => {
                                                return <>

                                                    <rsuite.Checkbox onChange={(e, checked) => {
                                                        Change_Item?.(rowData.Row, checked, 'IsActive');
                                                    }}
                                                        checked={rowData.IsActive} value={rowData.IsActive} /> &nbsp;
                                                    <text className={rowData.IsToday && rowData.IsActive ? 'text-success fw-bold ' :
                                                        rowData.IsToday && !rowData.IsActive ? 'text-danger fw-bold ' :
                                                            ""}>
                                                        <text className={!rowData.IsActive ? '' : "hide"}> غیر </text>
                                                        فعال
                                                    </text>

                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={2} sortable resizable>
                                        <rsuite.Table.HeaderCell > وضعیت فروش آنلاین </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell >
                                            {(rowData) => {
                                                return <>

                                                    <rsuite.Checkbox onChange={(e, checked) => {
                                                        Change_Item?.(rowData.Row, checked, 'WebIsActive');
                                                    }}
                                                        checked={rowData.WebIsActive} value={rowData.WebIsActive} /> &nbsp;
                                                     <text className={rowData.IsToday && rowData.WebIsActive ? 'text-success fw-bold ' :
                                                        rowData.IsToday && !rowData.WebIsActive ? 'text-danger fw-bold ' :
                                                            ""}>
                                                        <text className={!rowData.WebIsActive ? '' : "hide"}> غیر </text>
                                                        فعال
                                                    </text>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>

                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >


        </Layout >


    )
}

export default SalesSituationIndex;